const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
console.log("queryString...",queryString);
var hsID = urlParams.get("healthspanid");
if (hsID) {
  localStorage.setItem("healthspanid", hsID);
} else {
  hsID = localStorage.getItem("healthspanid");
}
let preload = document.getElementById("preloader-report");
if(preload){ 
  document.getElementById("preloader-report").style.display = "flex";
  setTimeout(() => {
      document.getElementById("preloader-report").style.display = "none";
  }, 1500);
}
let name = document.querySelector('.gut-report-page .client-name .Quiz-user');
let age = document.querySelector('.gut-report-page .info-item .age');
let gender = document.querySelector('.gut-report-page .info-item .gender');
let height = document.querySelector('.gut-report-page .info-item .height');
 let weight = document.querySelector('.gut-report-page .info-item .weight');
let activity =document.querySelector('.gut-report-page .info-item .activity');
let bst = document.querySelector('.gut-report-page .info-item .bst');
let totalscore = document.querySelector('.gut-report-page .info-item .score');
let symptoms = document.querySelector('.gut-report-page .info-item .symptoms');
let medication = document.querySelector('.gut-report-page .info-item .medication');
let overall = document.querySelector('.gut-report-page .stats-container .stat-box .totalscore');
let areas = document.querySelector('.gut-report-page .stats-container .stat-box .areas');
let bristol = document.querySelector('.gut-report-page .stats-container .stat-box .bristol');
let fiber = document.querySelector('.gut-report .macronutrient-needs .macro-grid .macronutrient1');
let water = document.querySelector('.gut-report .macronutrient-needs .macro-grid .macronutrient2');
let card = document.querySelector('.gut-health-kit .kit-contents .product-card.Above_bmi');
let totalprice = document.querySelector("#gut-personalized-plan .plan-container .pricing-details .final-price s");
let price = document.querySelector("#gut-personalized-plan .plan-container .pricing-details .final-price strong");
let frequency = document.querySelector(".gut-report-page .projection-stats .projection-stat-box .projection-stat-value");
let consistency = document.querySelector(".gut-report-page .projection-stats .projection-stat-box .projection-stat-value.consistency");

let gutbuttons = document.querySelectorAll(".gut-report .bmi-status .gut-buttons label");
let requires = document.querySelector(".gut-report .bmi-status .gut-buttons label.requires");
let needs = document.querySelector(".gut-report .bmi-status .gut-buttons label.needs");
let good = document.querySelector(".gut-report .bmi-status .gut-buttons label.good");
let gut_status = document.querySelector(".gut-report .bmi-status .gut-status-text");
let gut_health_kit = document.querySelector(".container.gut-health-kit");
let gut_description =  document.querySelector('.gut-report-page .stats-container .stat-description.gut-description');

console.log('gut_health_kit:',gut_health_kit);
let apiResult = { };
console.log('apiResult:',apiResult);
window.addEventListener('load', function () {
  const apiUrl = `https://api.thehealthspanco.com/api/v1/gut/get/${hsID}`;
  fetch(apiUrl, {
    method: 'GET', 
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json(); 
    })
    .then((result) => {
      console.log(result);
      const data = result?.data;
       apiResult = result?.data;
      
      if (data) {
        if(name){
           name.innerText = result?.data?.name;
        }
        if(gender){
           gender.innerText = result?.data?.gender;
        }
         if(age){
           age.innerText = result?.data?.age+" years";
        }
        if(height){
          height.innerText = result?.data?.height+" cm"
        }
        if(weight){
          weight.innerText = result?.data?.weight+" kg"
        }
        if(activity){
          activity.innerText = result?.data?.phyiscal_activity;
        }
        if(bst){
          bst.innerText = result?.data?.bst;
        }
        if(totalscore){
          totalscore.innerText = result?.data?.currentscore+"/10";
        }
        if(symptoms){
          symptoms.innerText = result?.data?.bothered;
        }
        if(medication){
          medication.innerText = result?.data?.medication;
        }
        if(overall){
          overall.innerText = result?.data?.currentscore;
        }
        if(areas){
          let concerns = result?.data?.concerns;
          let length = concerns.length;
          areas.innerText = length;
        }
        if(bristol){
          bristol.innerText = result?.data?.bst;
        }
        if(fiber){
          fiber.innerText = result?.data?.daily_requirements?.fiber?.gram +" grams";
        }
        if(water){
          water.innerText = result?.data?.daily_requirements?.water?.liters +" liters";
        }
        let perfect = result?.data?.bmi?.category;
        if(perfect === "Perfect"){
          card.style.display="none";
           totalprice.innerText = "₹2,699";
          price.innerText ="₹1,949";
        }else{
          totalprice.innerText = "₹3,999";
          price.innerText ="₹2,499";
        }
        if(frequency){
          frequency.innerText = result?.data?.pass_stoll;
        }
       let range = result?.data?.range;
       if(range){
          gutbuttons.forEach((item)=>{
              item.classList.remove("show");
            })
          if(range === "Urgent Care Needed" || range === "Need serious care" || range === "Need some care"){
             requires.classList.add("show");
            if(gut_description){
              gut_description.innerText = "Requires Attention"
            }
            
             if(gut_status){
               gut_status.innerText ="Hi, based on your gut score, it seems that you and your microbes need some immediate love and care. However, it's definitely possible to make a significant improvement starting with some basic lifestyle tweaks and gut nourishing supplements. Also this transformation will be cheaper & easier than what you imagine. Please go through our recommendations and start your fitness journey as soon as possible."
             }
          }
          if( range === "Need Minimal Intervention"){
              needs.classList.add("show");
             if(gut_description){
              gut_description.innerText = "Needs Improvement"
            }
            if(gut_status){
               gut_status.innerText ="Hello, Your gut health score is not bad, but with a few minor tweaks, we can make sure that you and your microbes are much happier! And we can make this happen in just 6-8 weeks, with some lifestyle tweaks and few gut nourishing supplements. Also it won't cost you much but you feel a lot more energetic and happier. Please go through our recommendations and start your fitness journey. Our Gut Health Kit solves for Bloating, Acidity, Gas, Constipation and Weight Gain. "
            }
          }
           if(range === "Your Gut Health is Great. No Intervention needed"){
              good.classList.add("show");
             if(gut_status){
               gut_status.innerText ="Well done, you’re doing very good! Your microbes will be happy and grateful with your lifestyle. Continue focussing on keeping your gut in good condition in future as well. And you’re already doing the right things for that. "
            }
              if(gut_description){
              gut_description.innerText = "Good"
            }
             if(gut_health_kit){
               gut_health_kit.style.display="none";
             }
             
          }
        }
      }
      if(consistency){
        let consistency_value = result?.data?.bst;
        if(consistency_value === "Type 1"){
          consistency.innerText = "Pebbly";
        }else if(consistency_value === "Type 2"){
          consistency.innerText = "Lumpy";
        }else if(consistency_value === "Type 3"){
          consistency.innerText = "Cracked";
        }else if(consistency_value === "Type 4"){
          consistency.innerText = "Smooth";
        }else if(consistency_value === "Type 5"){
          consistency.innerText = "Soft"
        }else{
          consistency.innerText ="Mushy"
        }
      }
    })
    .catch((error) => console.error('Error fetching the API:', error));
});

let download_report = document.querySelector('.life-con .btn-primary');
if(download_report){
  download_report.addEventListener('click',()=>{
    document.querySelector('.main-chat-box').style.display="none";
    const fullUrl = window.location.href;
    let headerbar = document.querySelector("body .shopify-section.shopify-section-group-header-group.shopify-section--header");
    headerbar.classList.add('highlight');
    const now = new Date();
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = now.toLocaleDateString('en-US', options).replace(',', '');
    html2canvas(document.body).then((canvas) => {
        const image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        let filename = `report_${formattedDate}.png`;
        link.href = image;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);      
    }).catch((error) => {
        console.error('Screenshot failed:', error);
    });
  setTimeout(() => {
     headerbar.classList.remove('highlight');
    document.querySelector('.main-chat-box').style.display="block";
  }, 1000);
})
}


let buyNow = document.querySelector("#gut-personalized-plan .plan-container .btn.btn-primary.buyNow");

buyNow?.addEventListener('click',()=>{
    let perfect = apiResult?.bmi?.category;
    let id;
    if(perfect === "Perfect"){
      id = buyNow.getAttribute('att');
    }else{
     id = 49948889743658;
    }
  
  console.log("Varinat id:",id);
  var formdata = {
    items: [{ id: id, quantity: 1,properties: {hsid: hsID }}],
  };
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
   .then((response) => {
      return response.json();
    })
   .then((response) => {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formdata),
      })
       .then((response) => {
          return response.json();
        })
       .then((response) => {
        
          fetch(window.location.href)
           .then((response) => {
              return response.text();
            })
           .then((html) => {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var header = doc.querySelector("header");
              document.querySelector("header").innerHTML = header.innerHTML;
              console.log('Header:............... ',header);
              // Reload the cart-drawer element
              var cartDrawer = doc.querySelector("#cart-drawer");
              document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;

              // Simulate a click on the cart link to open the cart drawer
              var cartLink = document.querySelector('a[aria-controls="cart-drawer"]');
              cartLink.click();
            });
          document.querySelectorAll('.buy-now-preloader').forEach((load)=>{
                load.style.display = 'none';
           })
        })   
          
       .catch((error) => {
          console.error("Error: ", error);
         });
    })
   
   .catch((error) => {
      console.error("Error: ", error);
     });

})
